module.exports = __webpack_public_path__ + "static/img/iconfont.539ab22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/iconfont.svg?t=1571211739842
// module id = Fe2/
// module chunks = 15